import api from './api';

const PAGE_SIZE = 10;

export const listarUsuariosV2 = (page, nome, ativo) =>
  api.get('/Usuario/list', {
    params: {
      page,
      numeroRegistros: PAGE_SIZE,
      nome: nome || undefined,
      ativo,
    },
  });

export const listarClientesV2 = (page, nome, numeroRegistros, ativo) =>
  api.get('/Cliente/list', {
    params: {
      page,
      numeroRegistros: numeroRegistros || PAGE_SIZE,
      nome: nome || undefined,
      ativo,
    },
  });

export const listarGruposV2 = nome =>
  api.get('/GrupoUsuario/list', { params: { nome: nome || undefined } });

export const listarConsultasV2 = (page, nome, numeroRegistros = PAGE_SIZE) =>
  api.get('/Consulta/list', {
    params: { page, numeroRegistros, nome: nome || undefined },
  });

export const listarMatrizesV2 = nome =>
  api.get('/Matriz/list', { params: { nome: nome || undefined } });

export { PAGE_SIZE };
